<ButtonInputStyleProvider :type="styleType"><input v-bind="$attrs" :type="type" @click.stop=""></ButtonInputStyleProvider>